<mat-card id="card" fxLayout="column" class="mainContentBody">
  <mat-card-content fxFlex [style.overflow]="'auto'" fxLayout="column" class="mainContentBodyContent">
    <h2>Dettagli colloquio conoscitivo</h2>
    <div fxLayout="column" class="responsive-mat-form">
      <form [formGroup]="form" fxLayout="column">

        <!-- Id field -->
        <mat-form-field>
          <input matInput formControlName="id" placeholder="Colloquio ID" readonly="true" />
        </mat-form-field>

        <!-- Nome field -->
        <mat-form-field fxlayout="column">
          <input matInput formControlName="nome" maxLength="256" placeholder="Nome" />
          <mat-error *ngIf="form.get('nome').errors?.required">
            Campo obbligatorio
          </mat-error>
        </mat-form-field>

        <!-- Cognome field -->
        <mat-form-field fxlayout="column">
          <input matInput formControlName="cognome" maxLength="256" placeholder="Cognome" />
          <mat-error *ngIf="form.get('cognome').errors?.required">
            Campo obbligatorio
          </mat-error>
        </mat-form-field>

        <!-- NumTelefono field -->
        <mat-form-field fxlayout="column">
          <input matInput formControlName="numTelefono" maxLength="256" placeholder="Numero di telefono" />
          <mat-error *ngIf="form.get('numTelefono').errors?.required">
            Campo obbligatorio
          </mat-error>
          <mat-error *ngIf="form.get('numTelefono').errors?.numeroInvalido">
            Il campo dev'essere un numero di telefono valido
          </mat-error>
        </mat-form-field>

        <!-- Email field -->
        <mat-form-field fxlayout="column">
          <input matInput formControlName="email" maxLength="256" placeholder="e-mail" />
          <mat-error *ngIf="form.get('email').errors?.required">
            Campo obbligatorio
          </mat-error>
          <mat-error *ngIf="form.get('email').errors?.email">
            Il campo deve essere un'email valida
          </mat-error>
        </mat-form-field>

        <!-- Istruzione + voto -->
        <div fxLayout="row" fxLayout.xs="column" fxLayout.sm="column" class="responsive-mat-form">
            <!-- Istruzione field -->
            <mat-form-field fxFlex="100"
            [ngStyle]="{'padding-right': 2 + '%'}" [ngStyle.xs]="{'padding-right.px': 0}"
            [ngStyle.sm]="{'padding-right.px': 0}" [ngStyle.md]="{'padding-right.px': 0}">
                <input matInput formControlName="istruzione" maxLength="256" placeholder="Istruzione" />
                <mat-error *ngIf="form.get('istruzione').errors?.required">
                    Campo obbligatorio
                </mat-error>
            </mat-form-field>
            <!-- Voto field -->
            <mat-form-field>
            <mat-label>Voto</mat-label>
            <mat-select formControlName="votoIstruzione">
              <mat-option *ngFor="let voto of votiIstruzione" [value]="voto">
                {{voto}}
              </mat-option>
            </mat-select>
            <mat-error *ngIf="form.get('votoIstruzione').errors?.required">
                Campo obbligatorio
            </mat-error>
          </mat-form-field>
        </div>

        <!-- Voti Colloquio -->
        <div fxLayout="row" class="responsive-mat-form" fxLayoutAlign="start center">

            <div fxLayout="column"  [style.width.%] = "33"
            [ngStyle]="{'padding-right': 2 + '%'}">
                <!-- Voto Quiz field -->
                <mat-form-field>
                    <mat-label>Voto Quiz</mat-label>
                    <mat-select formControlName="votoQuiz">
                    <mat-option *ngFor="let voto of voti" [value]="voto">
                        {{voto}}
                    </mat-option>
                    </mat-select>
                    <mat-error *ngIf="form.get('votoQuiz').errors?.required">
                        Campo obbligatorio
                    </mat-error>
                </mat-form-field>
                <!-- Voto Spigliatezza field -->
                <mat-form-field>
                    <mat-label>Voto Spigliatezza</mat-label>
                    <mat-select formControlName="votoSpigliatezza">
                    <mat-option *ngFor="let voto of voti" [value]="voto">
                        {{voto}}
                    </mat-option>
                    </mat-select>
                    <mat-error *ngIf="form.get('votoSpigliatezza').errors?.required">
                        Campo obbligatorio
                    </mat-error>
                </mat-form-field>
            </div>
            <div fxLayout="column" [style.width.%] = "33"
            [ngStyle]="{'padding-right': 2 + '%'}">
                <!-- Voto Comprensione field -->
                <mat-form-field>
                    <mat-label>Voto Comprensione</mat-label>
                    <mat-select formControlName="votoComprensione">
                    <mat-option *ngFor="let voto of voti" [value]="voto">
                        {{voto}}
                    </mat-option>
                    </mat-select>
                    <mat-error *ngIf="form.get('votoComprensione').errors?.required">
                        Campo obbligatorio
                    </mat-error>
                </mat-form-field>
                <!-- Voto Logica field -->
                <mat-form-field>
                    <mat-label>Voto Logica</mat-label>
                    <mat-select formControlName="votoLogica">
                    <mat-option *ngFor="let voto of voti" [value]="voto">
                        {{voto}}
                    </mat-option>
                    </mat-select>
                    <mat-error *ngIf="form.get('votoLogica').errors?.required">
                        Campo obbligatorio
                    </mat-error>
                </mat-form-field>
            </div>
            <div fxLayout="column" [style.width.%] = "33">
                <!-- Voto Totale field -->
                <mat-form-field>
                    <mat-label>Voto Totale</mat-label>
                    <mat-select formControlName="voto">
                    <mat-option *ngFor="let voto of voti" [value]="voto">
                        {{voto}}
                    </mat-option>
                    </mat-select>
                    <mat-error *ngIf="form.get('voto').errors?.required">
                        Campo obbligatorio
                    </mat-error>
                </mat-form-field>
            </div>
        </div>

        <!-- DataColloquio field -->
        <mat-form-field fxFlex="30" fxFlex.md="30" fxFlex.sm="100" fxFlex.xs="100"
            [ngStyle]="{'padding-right': 2 + '%'}" [ngStyle.xs]="{'padding-right.px': 0}"
            [ngStyle.sm]="{'padding-right.px': 0}" [ngStyle.md]="{'padding-right.px': 0}">
            <input matInput [min]="minDate" [max]="today" [matDatepicker]="picker" formControlName="dataColloquio"
                placeholder="Seleziona data" (click)="picker.open()" readonly="true">
            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
            <button mat-button *ngIf="form.get('dataColloquio').value" matSuffix mat-icon-button aria-label="Clear"
                (click)="form.get('dataColloquio').setValue(null)">
                <mat-icon>close</mat-icon>
            </button>
            <mat-error *ngIf="form.get('dataColloquio').errors?.required">
                Campo obbligatorio
            </mat-error>
        </mat-form-field>

        <!-- Descrizione field -->
        <mat-form-field fxlayout="column">
          <textarea cdkTextareaAutosize matInput formControlName="descrizione" placeholder="Descrizione"
            [readonly]="!isJappTenantAdmin()" maxlength="4000"></textarea>
          <mat-error *ngIf="form.get('descrizione').errors?.required">
            Campo obbligatorio
          </mat-error>
        </mat-form-field>

        <!-- Campi di informazione operazione -->
        <mat-expansion-panel class="mat-elevation-z0">
          <mat-expansion-panel-header>
            <mat-panel-title>
              Dettagli operazione
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div fxLayout="row">
            <!-- InsertDate field -->
            <mat-form-field fxFlex="50" fxFlex.md="100" fxFlex.sm="100" fxFlex.xs="100"
              [ngStyle]="{'padding-right': 2 + '%'}" [ngStyle.xs]="{'padding-right.px': 0}"
              [ngStyle.sm]="{'padding-right.px': 0}" [ngStyle.md]="{'padding-right.px': 0}">
              <input matInput formControlName="insertDate" placeholder="Insert Date" readonly="true" />
            </mat-form-field>

            <!-- InsertUser field -->
            <mat-form-field fxFlex="50" fxFlex.md="100" fxFlex.sm="100" fxFlex.xs="100">
              <input matInput formControlName="insertUser" placeholder="Insert User" readonly="true" />
            </mat-form-field>
          </div>
          <div fxLayout="row">
            <!-- UpdateDate field -->
            <mat-form-field fxFlex="50" fxFlex.md="100" fxFlex.sm="100" fxFlex.xs="100"
              [ngStyle]="{'padding-right': 2 + '%'}" [ngStyle.xs]="{'padding-right.px': 0}"
              [ngStyle.sm]="{'padding-right.px': 0}" [ngStyle.md]="{'padding-right.px': 0}">
              <input matInput formControlName="updateDate" placeholder="Update Date" readonly="true" />
            </mat-form-field>

            <!-- UpdateUser field -->
            <mat-form-field fxFlex="50" fxFlex.md="100" fxFlex.sm="100" fxFlex.xs="100">
              <input matInput formControlName="updateUser" placeholder="Update User" readonly="true" />
            </mat-form-field>
          </div>
        </mat-expansion-panel>
      </form>
    </div>
    <mat-card-actions>
      <button mat-raised-button (click)="backConfirm(previousUrl)" color="primary">Back</button>
      <button mat-raised-button (click)="colloquioSave()" [disabled]="!form.dirty || form.invalid"
        *ngIf="colloquio?.deleteDate==null && isJappTenantAdmin()">Save</button>
      <button mat-raised-button (click)="colloquioDelete()" [disabled]="colloquio?.id==null"
        *ngIf="colloquio?.deleteDate==null && isJappTenantAdmin()">Delete</button>
    </mat-card-actions>
  </mat-card-content>
</mat-card>